/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteLocationCommand } from '../../models/delete-location-command';
import { DeleteLocationCommandResult } from '../../models/delete-location-command-result';

export interface ApiLocationDeleteLocationDelete$Plain$Params {
      body?: DeleteLocationCommand
}

export function apiLocationDeleteLocationDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiLocationDeleteLocationDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteLocationCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationDeleteLocationDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteLocationCommandResult>;
    })
  );
}

apiLocationDeleteLocationDelete$Plain.PATH = '/api/Location/DeleteLocation';
